// ============================================================================
// page-projects / filter.js
// ----------------------------------------------------------------------------
// Filter bar above the projects list.
//
//   .projects__filter-head        Horizontal Flickity strip of filter pills.
//   .projects__filter-head-item   One pill per filter key (Building,
//                                 Architecture style, Site area, Industry).
//                                 The `filter` HTML attribute on each item
//                                 matches the `filter` attribute on its
//                                 corresponding body panel.
//   .projects__filter-body        One panel per filter key. All start
//                                 collapsed (height: 0).
//
// Behaviour:
//   - Click a pill → toggles `.active` on it.
//   - Active pill expands its matching body to its natural height; all
//     other bodies collapse.
//   - Click the same active pill again → collapses everything (toggle).
//   - Drag-to-scroll on the pill strip does NOT trigger a toggle, thanks to
//     Flickity's `staticClick` event (fires only on a real, non-drag click).
//
// Uses the shared carousel engine so Flickity options stay consistent
// site-wide and we don't double-bundle the library.
// ============================================================================

import { initCarousels } from "../carousel";

document.addEventListener("DOMContentLoaded", function () {
  const headEl = document.querySelector(".projects__filter-head");
  const headItems = document.querySelectorAll(".projects__filter-head-item");
  const bodyEls = document.querySelectorAll(".projects__filter-body");

  if (!headEl || !headItems.length) return;

  // Original inline code set display:block before Flickity init so the cells
  // lay out as blocks. Keep the side effect.
  headEl.style.display = "block";

  const instances = initCarousels(".projects__filter-head", {
    cellAlign: "left",
    contain: true,
    pageDots: false,
    wrapAround: false,
  });
  if (!instances || !instances.length) return;
  const flkty = instances[0].flickity;

  // Cache each body's natural height while it's still rendered, then collapse.
  // `scrollHeight` works even when an element is about to be height-clamped
  // (and is what the newer inline version in Div #443 used).
  bodyEls.forEach(function (bodyEl) {
    bodyEl.setAttribute("data-natural-height", bodyEl.scrollHeight);
    bodyEl.style.height = "0px";
    bodyEl.style.pointerEvents = "none";
    bodyEl.style.transition = "300ms";
  });

  // `staticClick` fires only on a click that wasn't part of a drag — perfect
  // for togglable pills inside a draggable strip.
  flkty.on("staticClick", function (event, pointer, cellElement) {
    if (!cellElement) return;

    const filterKey = cellElement.getAttribute("filter");
    const wasActive = cellElement.classList.contains("active");

    // Reset everything first.
    headItems.forEach(function (item) {
      item.classList.remove("active");
    });
    bodyEls.forEach(function (bodyEl) {
      bodyEl.style.height = "0px";
      bodyEl.style.pointerEvents = "none";
    });

    // Second click on the same pill → leave collapsed (toggle off).
    if (wasActive) return;

    cellElement.classList.add("active");

    bodyEls.forEach(function (bodyEl) {
      if (bodyEl.getAttribute("filter") !== filterKey) return;
      const h =
        parseInt(bodyEl.getAttribute("data-natural-height"), 10) + 40 || 0;
      bodyEl.style.height = h + "px";
      bodyEl.style.pointerEvents = "all";
    });
  });
});
